const dims = { borderRadius: "6px", px: 1, py: "1px" }

export const regimeStatusSx = {
    draft: { ...dims, bgcolor: "lightBlue", color: "grey.800" },
    review: { ...dims, bgcolor: "warmYellow", color: "grey.800" },
    candidate: { ...dims, bgcolor: "primary.main", color: "common.white" },
    live: { ...dims, bgcolor: "darkGreen", color: "common.white" },
}
